export const selectedData = [
    {
      "name": "Prarthavi Prashant Garge",
      "reg": "20BCE0420"
    },
    {
      "name": "Khushang Thakkar",
      "reg": "20BCE2014"
    },
    {
      "name": "Srikar Rajagopalan",
      "reg": "20BCE2261"
    },
    {
      "name": "AMARJIT DEY",
      "reg": "20BEC0297"
    },
    {
      "name": "GOPAGONI KARTHIK GOUD",
      "reg": "20BKT0130"
    },
    {
      "name": "HARSH NARENDRABHAI DETROJA",
      "reg": "20BCE2814"
    },
    {
      "name": "Ananya Thakre",
      "reg": "20BCT0269"
    },
    {
      "name": "Rohit V Bhandarkar",
      "reg": "21BCE0010"
    },
    {
      "name": "Astha Madhukar Sul",
      "reg": "21BCE0288"
    },
    {
      "name": "Dhenuvakonda Sai Naveen",
      "reg": "21BCE0336"
    },
    {
      "name": "Rijul",
      "reg": "21BCE0342"
    },
    {
      "name": "Ujjwal Jain",
      "reg": "21BCE0352"
    },
    {
      "name": "Mehul Parashar",
      "reg": "21BCE0546"
    },
    {
      "name": "Vansh Mitesh Dalal",
      "reg": "21BCE0635"
    },
    {
      "name": "Aditya Ajay Iyer",
      "reg": "21BCE0699"
    },
    {
      "name": "Aditya Dhanraj",
      "reg": "21BCE0747"
    },
    {
      "name": "Muskan",
      "reg": "21BCE0811"
    },
    {
      "name": "Tanya Batra",
      "reg": "21BCE0818"
    },
    {
      "name": "Saakshi Singh Chauhan",
      "reg": "21BCE2325"
    },
    {
      "name": "Satwika B",
      "reg": "21BCE2496"
    },
    {
      "name": "Pal Jignesh Patel",
      "reg": "21BCE2603"
    },
    {
      "name": "Udai Jain",
      "reg": "21BCE2713"
    },
    {
      "name": "Kandiraju Krishna Rishik",
      "reg": "21BCE2764"
    },
    {
      "name": "Ayush Kumar",
      "reg": "21BCE2765"
    },
    {
      "name": "Akansh Bansal",
      "reg": "21BCE3280"
    },
    {
      "name": "Aryan Chaudhary",
      "reg": "21BCE3768"
    },
    {
      "name": "Rahul Kumar Sah",
      "reg": "21BCE3932"
    },
    {
      "name": "Aviral Soni",
      "reg": "21BCI0029"
    },
    {
      "name": "Nakshatra Singh Raghav",
      "reg": "21BCE2728"
    },
    {
      "name": "Kritika Sapra",
      "reg": "21BCT0184"
    },
    {
      "name": "Sushrith Reddy A",
      "reg": "21BDS0214"
    },
    {
      "name": "Devanshi Vashisht",
      "reg": "21BIT0068"
    },
    {
      "name": "Harsh Agrawal",
      "reg": "21BIT0412"
    },
    {
      "name": "Aditya Kanchan Baras",
      "reg": "21BIT0468"
    },
    {
      "name": "Shreya Sonawane",
      "reg": "21BKT0044"
    },
    {
      "name": "Shaswat Singh",
      "reg": "21BKT0052"
    },
    {
      "name": "Tunuguntla S L Subrahmanyam",
      "reg": "21BME0007"
    },
    {
      "name": "Sri Nidhi S",
      "reg": "21MIS0007"
    },
    {
      "name": "Rishabh Sukhwani",
      "reg": "21BCE2692"
    },
    {
      "name": "Gomathinayagam R",
      "reg": "21BAR0042"
    },
    {
      "name": "Saksham Gupta",
      "reg": "21BBS0180"
    },
    {
      "name": "Shreya Gupta",
      "reg": "21BCB0142"
    },
    {
      "name": "Anushka Jain",
      "reg": "21BCE0038"
    },
    {
      "name": "Shreya Girish Savadatti",
      "reg": "21BCE0118"
    },
    {
      "name": "Aryan Gupta",
      "reg": "21BCE0210"
    },
    {
      "name": "Jatin Virendra Patil",
      "reg": "21BCE0389"
    },
    {
      "name": "Harsh Gupta",
      "reg": "21BCE0492"
    },
    {
      "name": "Ashish Gupta",
      "reg": "21BCE0569"
    },
    {
      "name": "Prajwal Sinha",
      "reg": "21BCE0713"
    },
    {
      "name": "Preeti Modi",
      "reg": "21BCE1310"
    },
    {
      "name": "Sanjana S",
      "reg": "21BCE2700"
    },
    {
      "name": "Ananya Priyadarshini",
      "reg": "21BCE2739"
    },
    {
      "name": "Khushi Teli",
      "reg": "21BCE2755"
    },
    {
      "name": "Aaditya Prabal Chawla",
      "reg": "21BCE2815"
    },
    {
      "name": "Amal Vatsa",
      "reg": "21BCE3194"
    },
    {
      "name": "Gupta Neil Rajesh",
      "reg": "21BCE3928"
    },
    {
      "name": "Sakshi Jha",
      "reg": "21BCE3938"
    },
    {
      "name": "Himanshu Kumar Modi",
      "reg": "21BCI0011"
    },
    {
      "name": "Sidhartha Jha",
      "reg": "21BCI0020"
    },
    {
      "name": "Naeema Khatoon",
      "reg": "21BCI0330"
    },
    {
      "name": "Parmitha Reddy",
      "reg": "21BDS0047"
    },
    {
      "name": "Puja Balasundaram",
      "reg": "21BDS0188"
    },
    {
      "name": "Kothari Vidhi Deepak",
      "reg": "21BDS0197"
    },
    {
      "name": "Aadit Shah",
      "reg": "21BDS0203"
    },
    {
      "name": "Chinmay Paliwal",
      "reg": "21BDS0215"
    },
    {
      "name": "Anshika Singh",
      "reg": "21BDS0273"
    },
    {
      "name": "Dishanwita Ghosh Chowdhury",
      "reg": "21BEC0198"
    },
    {
      "name": "Venya Singh",
      "reg": "21BEC2053"
    },
    {
      "name": "Sanjana Bhattacharjee",
      "reg": "21BEC2146"
    },
    {
      "name": "Priya Shukla",
      "reg": "21BEC2379"
    },
    {
      "name": "Anshaj Singh Parihar",
      "reg": "21BEE0079"
    },
    {
      "name": "Bhavika Panjwani",
      "reg": "21MID0244"
    },
    {
      "name": "Thinesh  Raja J",
      "reg": "21BEE0238"
    },
    {
      "name": "Shaurya Pratap Singh",
      "reg": "21BIT0049"
    },
    {
      "name": "Prabhav Gupta",
      "reg": "21BIT0062"
    },
    {
      "name": "Preet Patel",
      "reg": "21BIT0142"
    },
    {
      "name": "Manan Anil Sharma",
      "reg": "21BIT0221"
    },
    {
      "name": "Tejasv Rastogi",
      "reg": "21BIT0558"
    },
    {
      "name": "Annavarapu Sathwik",
      "reg": "21BME0155"
    },
    {
      "name": "Kasi Reddy Ravinder Reddy",
      "reg": "21MID0018"
    },
    {
      "name": "Aryan Jain",
      "reg": "21BCE0006"
    }
]